__webpack_require__.p = "https://react-general-staging.staffshift.com/";